export const ADMIN_BASIC_SCHEMA = [
  {
    elementConfig: {
      label: "Full Name",
      placeholder: "Full Name",
      type: "text",
    },
    elementType: "input",
    name: "name",
  },
  {
    elementConfig: {
      label: "Customer Success Type",
      placeholder: "Customer Success Type",
      type: "text",
    },
    elementType: "input",
    name: "user_type",
  },
  {
    elementConfig: {
      label: "Email",
      placeholder: "Email",
      type: "email",
    },
    elementType: "input",
    name: "email",
  },
  {
    elementConfig: {
      label: "Mobile",
      placeholder: "Mobile",
      type: "text",
    },
    elementType: "input",
    name: "mobile",
  },
];
